






















































































































import VehicleChooserForCurrentCompany from '../../vehicles/components/VehicleChooserForCurrentCompany.vue';
import  Loading from 'vue-loading-overlay';
import { AuthStoreHelper, RootStoreHelper, VehicleCompanyStoreHelper } from '../../core/mixins';
import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import {
    PlayBackInfo,
    PlaybackState,
    mapFromRangeToRange,
    getDateFromDateFormatApi,
    getStringTimeFromDate,
    sortObjectByPropertyName,
    TypeVehicleState,
    getStateByNumber,
    removeAccentsFromString,
    addTimeToDate,
    getNowNoFormat,
    formatDate,
    watchClass,
    getMomentPlusTime,
    tableSort,
    downloadJsonData,
    getActualTimestamp,
    EventBus,
    TypeEventBus,
    PRIVILEGE_KEYS
} from '../../core/utils';
import CardPlayBackInfo from './CardPlayBackInfo.vue';
import { dateTypes, diffOptions, UserCustomization } from '../../core/models';
import { UserService } from '../../core/api';
import { getVehiclePlateFromVehicleId, getVehicleVinById }from '../../core/mixins/';
import { Destroyed } from '../../core/decorators';
import { centerVehicleInMap, VariablesTypes } from '../utils';
import { getRowBasedOnVisibleHeadersAndUserSearch, getVehicleStateByNumberAsText } from '../../core/utils/table-utils';
import FleetSummaryUserSettings from './FleetSummaryUserSettings.vue';
import multiselect from 'vue-multiselect';
import rowItem from './Table/rowItem.vue';
import Input from '../../core/components/Input.vue'; 
import SimpleTable from '../../core/components/SimpleTable.vue'; 
import Button from '../../core/components/Button.vue'; 
import ExportExcelButton from '../../core/components/ExportExcelButton.vue'; 
import { parseSpeedValue } from '../../core/components/Map';
import { getOTStateText } from '../../journeys/utils';
import { acopladoKey } from '../../../features/norms/utils';
@Component({
    components: { 
        FleetSummaryUserSettings,
        Loading,
        rowItem,
        multiselect,
        Input,
        SimpleTable,
        Button,
        ExportExcelButton,
        VehicleChooserForCurrentCompany
     }
})
export default class FleetSummaryTable extends Mixins(
    RootStoreHelper,
    VehicleCompanyStoreHelper
) {
   @Prop({default: null}) vehiclesList: Array<object>;
   @Prop({default: 50}) getItemsPerPage: number;
   @Prop({default: false}) shouldDisplayActualStateTable: boolean;
   @Prop({default: null}) getCurrentTimestamp: any;
   @Prop({default: 390}) getActualStateTableHeight: number;
   @Prop({default(){return []}}) itemsTableFleetSummary: Array<object>;
   filteredRowsByUser:Array<object> = [];
   selectedVehicle: null | string = null;
   downloadingItems: boolean = false;
   searchTableForFleetSummary: string = '';
   searchFleetSummaryTable: string = '';
   noItemsToDownloadText: string = 'No hay filas para descargar';
   downloadItemsText: string = 'Descargar tabla';
   debounce: any = null;
   sortBy: string[] = ['description'];
   sortDesc: boolean[] = [false];
   headersMDP: Array<object> = [
    {
            text: 'Nro OT',
            align: 'left',
            value: 'work_order_number',
            mdp: true
        },
        {
            text: 'Monte',
            align: 'left',
            value: 'work_order_mount',
            mdp: true
        },
        {
            text: 'Destino',
            align: 'left',
            value: 'work_order_dest',
            mdp: true
        },
        {
            text: 'Hora Descarga',
            align: 'center',
            value: 'work_order_unload_date',
            mdp: true
        },
        {
            text: 'Estado Carga',
            align: 'left',
            value: 'work_order_load_state',
            mdp: true
        },
   ]
   headersTableFleetSummary: Array<object> = [
        {
            text: 'Vehículo',
            align: 'left',
            value: 'description',
             filter: this.filterByVehicleDescription
        },
        {
            text: 'Matricula',
            align: 'center',
            value: 'vehicle_plate',
        },
        {
            text: 'Norma',
            align: 'center',
            value: 'nro_norma'
        },
        {
            text: 'VIN',
            align: 'center',
            value: 'vin'
        },
        {
            text: 'Ultimo reporte',
            align: 'center',
            value: 'last_message_time_diff'
        },
        {
            text: 'Estado del vehículo',
            align: 'center',
            value: 'vehicle_state'
        },
        {
            text: 'Velocidad',
            align: 'center',
            value: 'speed'
        },
        {
            text: 'Ubicación aproximada',
            align: 'left',
            value: 'location'
        },
        {
            text: 'Chofer',
            align: 'center',
            value: 'driver_name'
        },
        {
            text: 'Chofer',
            align: 'center',
            value: 'driver_name'
        },
        {
            title: 'Camión Acoplado',
            align: 'center',
            value: acopladoKey,
        },
        ...this.headersMDP
   ];

   updateSelectedVehicle(value){
    this.selectedVehicle = value;
   }

   get getExcelFileName(){
    let name = 'resumen_de_flota_empresa_';
    if(this.$_getSelectedCompany){
        name += this.$_getSelectedCompany['name']
    }
    return name
   }
   

    formatLoadState(value){
        return getOTStateText(value)
    }

   clearVehicleSelected(){
    this.selectedVehicle = null;
   }

   @Emit()
   showVehicleInMap(positions){return positions}

   get getItemsTableFleetSummary(){
    let filteredIds = this.$_getFilteredLastReportVehicles;

    return  this.itemsTableFleetSummary.filter(
        item => filteredIds.includes(Number(item['vehicle_id']))
    ).map(item => item)
   }

   customFilterForFleetSummary(items, userSearch, currentRow):boolean {
    return getRowBasedOnVisibleHeadersAndUserSearch(userSearch, currentRow, this.headersTableFleetSummary)
   }


   @Watch('$_getSelectedVehiclesByID')
   observableSelectedVehicles(){
    this.searchTableForFleetSummary = '';
    this.searchFleetSummaryTable = '';
   }

   updateFilteredItemsFleetSummary(items){
    this.filteredRowsByUser = items;
   }

   dateFormatter(value){
    return formatDate(value)
   }

   filterByVehicleDescription(vehicleDescription:string) {
        return this.selectedVehicle == null ? true : vehicleDescription === this.selectedVehicle['description'];
    }

    filterSearch(value) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.searchFleetSummaryTable = value;
        }, 600);
    }

    updateHeadersFleetSummary(newHeaders){
        let self = this;
        this.headersTableFleetSummary = newHeaders.map(function(header){
            return {
                text: header['title'],
                align: header['key'] === 'description' ? 'left' : 'center',
                value: header['key'],
                ...(header['key'] === 'description' ? { filter: self.filterByVehicleDescription } : {})
            }
        })
    }




    viewVehicleInMap(item){
        let self = this;
        let position = [{
            lat: item.position.latitude, 
            lng: item.position.longitude
        }]
        
        this.showVehicleInMap(
            position
        )
    }

     customSortForFleetSummary(items: object[], sortBy: string[], sortDesc: boolean[]) {
        return tableSort(items, sortBy, sortDesc)
    }

    getMomentParsedTime(time) {
        return getMomentPlusTime(time)
    }

    getTimeDiff(value, type: diffOptions){
        return addTimeToDate(getNowNoFormat(), value, type)  
    }


     getParseTime(time) {
        if (!time.match(/(\d+)/))
            return {
                measure: null,
                value: null
            };
        let timeValue = time.match(/(\d+)/)[0];
        let timeMeasure = time.substring(time.indexOf(' ') + 1);
        return {
            measure: timeMeasure,
            value: timeValue
        };
    }

    
    sortHeaders(updatedHeaders) {
        this.headersTableFleetSummary = updatedHeaders;
        let fleetSummaryModal = this.$refs.fleetSummarySettings as HTMLFormElement;
        let fleetSummaryTable = this.$refs.tableFleetSummary as HTMLFormElement;
        if(fleetSummaryModal && fleetSummaryTable){
            fleetSummaryModal.updateHeadersOrder(updatedHeaders);
        }
    }

    getVehicleStateAsText(vehicleState: {
        timestamp: string,
        value: number,
        time_diff: string
    }) {
        if(typeof vehicleState !== 'object'){
            return '-'
        }
        if(vehicleState && vehicleState.timestamp){
            return getVehicleStateByNumberAsText(vehicleState.value, vehicleState.timestamp)
        }
        if(vehicleState && vehicleState.value){
           return getVehicleStateByNumberAsText(vehicleState.value, null)
        }
        return '-'
    }

    get isMdpUser(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.MDP] == true;
    }

    get getTableHeaders(){
        let headers = this.headersTableFleetSummary;
        if(!this.isMdpUser){
            headers = headers.filter(function(header){
                return header['mdp'] !== true
            })
        }
        return headers
    }

    mounted(){

    }

}
